import React, { useEffect, useState } from 'react';
import Alert from "../../../utils/Alert.js";
import { serviceAcceptanceRequest } from '../../../services/servicesServices';

const ReceiveService = ({ rowData }) => {
    const [isChecked, setIsChecked] = useState(false);

    useEffect(() => {
        setIsChecked(rowData.checked)
    }, [])

    const handleCheckBoxChange = async (event) => {
        const checked = event.target.checked;
        setIsChecked(checked);
        try {
            const response = await serviceAcceptanceRequest(rowData.code, checked);
            if (response.status === 200) {
                // if (checked) {
                //     Alert("انجام عملیات", "درخواست پذیرش شما ارسال شد", "success");
                // } else {
                //     Alert("انجام عملیات", "درخواست پذیرش شما لغو شد", "success");
                // }
                window.location.reload();
            }
        } catch (error) {
            Alert("خطا", "در ارسال درخواست مشکلی به وجود آمده", "error");
        }
    }
    return (
        <span>      
            <form>
                <input 
                    type='checkbox' 
                    id='receiveService' 
                    name='receiveService' 
                    checked={isChecked} 
                    onChange={handleCheckBoxChange} 
                />
            </form>
        </span>  
    );
}

export default ReceiveService;
